import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BreadCrumb = _resolveComponent("BreadCrumb");
    const _component_VabeneLoyaltyReportList = _resolveComponent("VabeneLoyaltyReportList");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_BreadCrumb, {
            PageTitle: _ctx.$t('loyalty.reportTitle') || 'Rapport Fidélité'
        }, null, 8, ["PageTitle"]),
        _createVNode(_component_VabeneLoyaltyReportList)
    ], 64));
}
